import {
    fps,
    he, ico_he, ico_wi,
    picture_convert,
    reels_lenghts,
    reels_pos,
    server_config,
    wi,
    systemConfig,
    behavior_config
} from "../framework/src/engine/madnes/madnes_variables";
import {
    bet,
    madnes_fill_range, madnes_get_currtime,
    madnes_get_json, madnes_reverse,
    madnes_set_input_down,
    madnes_set_win_factors
} from "../framework/src/engine/madnes/madnes";

import {
    madnes_add_group,
    madnes_add_img,
    madnes_add_sprite, madnes_add_to_group, madnes_set_angle,
    madnes_set_img_center, madnes_set_pos, madnes_set_pos_x, madnes_set_pos_y,
    madnes_set_scale
} from "../framework/src/engine/madnes/madnes_object";
import {madnes_anim_add, madnes_anim_add_oncomplete, madnes_anim_play} from "../framework/src/engine/madnes/madnes_anims";

import {
    madnes_add_bitmap_text,
    madnes_add_text,
    madnes_set_bitmap_float
} from "../framework/src/engine/madnes/madnes_text";
import {madnes_audio_loop} from "../framework/src/engine/madnes/madnes_audio";
import {cylinder_pos} from "./wanted_config";
import {stopposin, stopposin_old} from "./wanted_core";
import {madnes_add_to_render, madnes_rem_from_render} from "../framework/src/engine/madnes/madnes_render";
import {
    wanted_saloon_back_end,
    wanted_saloon_back_middle,
    wanted_saloon_shoot, wanted_saloon_shoot_end,
    wanted_saloon_to_middle
} from "./wanted_saloon";
import {wanted_boom_done} from "./wanted_anims";
import {CONFIG_PARAMS} from "../framework/src/system/SystemConfig";

export let freepanelpos = 200;
export function set_freepanelpos(val) {
    freepanelpos = val;
}

var smoke_emitter;

// Vytvoreni potrebnych onjektu z nactenych textur.
export function wanted_print_desk()
{
    if(typeof behavior_config.reel.spin.motionBlur == "undefined")
    {
        behavior_config.reel.spin.motionBlur = 1;
    }

    if(typeof behavior_config.reel.spin.timeToReachFullSpeed == "undefined")
    {
        behavior_config.reel.spin.timeToReachFullSpeed = 0.5;
        if(typeof behavior_config.reel.acceleration.spinAccelerationRatio != "undefined")
        {
            behavior_config.reel.spin.timeToReachFullSpeed = behavior_config.reel.acceleration.spinAccelerationRatio;
        }
    }

    if(typeof behavior_config.reel.spin.timeToReachNullSpeed == "undefined")
    {
        behavior_config.reel.spin.timeToReachNullSpeed = 0.5;
        if(typeof behavior_config.reel.acceleration.spinAccelerationRatio != "undefined")
        {
            behavior_config.reel.spin.timeToReachNullSpeed = behavior_config.reel.acceleration.spinAccelerationRatio;
        }
    }

    //behavior_config.reel.spin.timeToReachNullSpeed = 0;

    if(typeof behavior_config.reel.acceleration.moveTime != "undefined")
    {
        behavior_config.reel.spin.timeToReachFullSpeed = behavior_config.reel.acceleration.moveTime;
    }

    if(typeof behavior_config.reel.brake.moveTime != "undefined")
    {
        behavior_config.reel.spin.timeToReachNullSpeed = behavior_config.reel.brake.moveTime;
    }

    if(behavior_config.reel.spin.timeToReachFullSpeed == 0)
    {
        behavior_config.reel.spin.timeToReachFullSpeed = 0.01;
    }

    if(behavior_config.reel.spin.timeToReachNullSpeed == 0)
    {
        behavior_config.reel.spin.timeToReachNullSpeed = 0.01;
    }

    if(behavior_config.reel.spin.timeToReachFullSpeed > 0.5)
    {
        behavior_config.reel.spin.timeToReachFullSpeed = 0.5;
    }

    if(behavior_config.reel.spin.timeToReachNullSpeed > 0.5)
    {
        behavior_config.reel.spin.timeToReachNullSpeed = 0.5;
    }

    madnes_set_win_factors(
        behavior_config.reel.minBigWinFactor,
        behavior_config.reel.minMegaWinFactor,
        behavior_config.reel.minSuperMegaWinFactor
    );

    if(
        typeof server_config.logic != "undefined" &&
        typeof server_config.logic.bet_set != "undefined"
    )
    {
        //bets = server_config.logic.bet_set;
        /*var bet0 = [];
        for(var b in server_config.logic.bet_set)
        {
            if(
                server_config.logic.bet_set[b] >= 10 &&
                server_config.logic.bet_set[b] <= 100
            )
            {
                bet0[bet0.length] = server_config.logic.bet_set[b];
            }
        }
        bets = bet_set = bet0;*/
    }

    // bets = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];

    /*
    for(var i in picture_convert)
    {
        madnes_add_sprite("tmp_buf_" + i, picture_convert[i], i * ico_wi % wi, Math.ceil( ( i * ico_he ) / wi ) * ico_he);
    }
    */

    var i = 8;
    madnes_add_sprite("tmp_buf_" + i, picture_convert[i], i * ico_wi % wi, Math.ceil( ( i * ico_he ) / wi ) * ico_he);

    madnes_add_img("background", "background", 0, 0);

    madnes_add_img("bonus_bg", "bonus_bg", 0, 0, 0);

    madnes_add_sprite("bonus_wheel", "bonus_wheel", 640, 330, 0, 0.5, 0.5);
    madnes_anim_add("bonus_wheel", "stop", [0]);
    madnes_anim_add("bonus_wheel", "blur", [1]);
    madnes_anim_play("bonus_wheel", "stop");

    madnes_add_sprite("bonus_shot", "bonus_shot", 640, 330, 0, 1.6, 1.6);
    madnes_anim_add("bonus_shot", "stop", [0]);
    madnes_anim_add("bonus_shot", "blur", [1]);
    madnes_anim_play("bonus_shot", "stop");

    madnes_add_img("bonus_flash", "bonus_flash", 410, 0, 0);

    madnes_add_sprite("bonus_colt", "bonus_colt", 640, 730, 0, 0.5, 1);
    madnes_anim_add("bonus_colt", "stop", [6]);
    madnes_anim_add("bonus_colt", "shoot", [12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,0,1,2,3,4,5]);
    madnes_anim_add_oncomplete("bonus_colt", function () {
        wanted_saloon_shoot_end();
    });
    madnes_anim_play("bonus_colt", "stop");

    madnes_add_img("bonus_paper", "bonus_paper", 480, 560, 0);
    madnes_add_img("button_fire", "button_FIRE_disabled", 504, 590, 0);

    var infotext = madnes_get_json("infotext");

    for(var i in infotext)
    {
        if(typeof infotext[i].name !== "undefined" && infotext[i].name == "bonus_fire")
        {
            var style = {
                "font": "34px Arial",
                "fill": "#ffffff",
                "fontWeight": "bold",
                "stroke": "#606060",
                "strokeThickness": 4
            };
            madnes_add_text("button_fire_text", wi / 2, -9999, infotext[i].content, style);
            madnes_set_img_center("button_fire_text", 0.5, -0.7);
        }
    }

    madnes_set_input_down("button_fire", function() {
        wanted_saloon_shoot();
    });

    ////////////////////////////////////////////////////////////////////////////////

    var style = {
        font: "26px Arial",
        fontWeight: "bold",
        fill: "#dd00cc",
        align: "left",
        boundsAlignH: "left",
        boundsAlignV: "top",
        wordWrap: false,
        wordWrapWidth: 300
    };

    // Nastaveni / vytvoreni pasu pro valce podle navratu ze serveru
    for(var i = 0; i < cylinder_pos.length; i++)
    {
        for(var j in server_config.logic.reels[i])
        {

            madnes_add_sprite("reels_bufer_" + i + "_" + j, picture_convert[server_config.logic.reels[i][j]] + "_blur", cylinder_pos[i], -9999);
            madnes_anim_add("reels_bufer_" + i + "_" + j, "blur", [0]);
            madnes_anim_add("reels_bufer_" + i + "_" + j, "stop", [1]);

            madnes_anim_play("reels_bufer_" + i + "_" + j, "stop");
            /*
            madnes_add_text("text_reels_bufer_" + i + "_" + j, cylinder_pos[i], -999, "reels_bufer_" + i + "_" + j, style);
            madnes_set_img_center("text_reels_bufer_" + i + "_" + j, 0, -2.5);
            */
            reels_lenghts[i] = j * 1 + 1;
            stopposin[i] = reels_lenghts[i];
            stopposin_old[i] = reels_lenghts[i];
        }

        // S0-S2 = priprava vyherni pozice na kazdem valci
        madnes_add_sprite("reels_bufer_" + i + "_S0", picture_convert[server_config.logic.failResult[i][2]] + "_blur", cylinder_pos[i], 10);
        madnes_add_sprite("reels_bufer_" + i + "_S1", picture_convert[server_config.logic.failResult[i][1]] + "_blur", cylinder_pos[i], 10);
        madnes_add_sprite("reels_bufer_" + i + "_S2", picture_convert[server_config.logic.failResult[i][0]] + "_blur", cylinder_pos[i], 10);


        madnes_add_sprite("reels_bufer_" + i + "_TMP0", picture_convert[0] + "_blur", cylinder_pos[i], -9999);
        madnes_add_sprite("reels_bufer_" + i + "_TMP1", picture_convert[0] + "_blur", cylinder_pos[i], -9999);
        madnes_add_sprite("reels_bufer_" + i + "_TMP2", picture_convert[0] + "_blur", cylinder_pos[i], -9999);

        /*
        madnes_add_text("text_reels_bufer_" + i + "_S0", cylinder_pos[i], -999, "reels_bufer_" + i + "_S0", style);
        madnes_add_text("text_reels_bufer_" + i + "_S1", cylinder_pos[i], -999, "reels_bufer_" + i + "_S1", style);
        madnes_add_text("text_reels_bufer_" + i + "_S2", cylinder_pos[i], -999, "reels_bufer_" + i + "_S2", style);

        madnes_set_img_center("text_reels_bufer_" + i + "_S0", 0, -2.5);
        madnes_set_img_center("text_reels_bufer_" + i + "_S1", 0, -2.5);
        madnes_set_img_center("text_reels_bufer_" + i + "_S2", 0, -2.5);
        */

        madnes_anim_add("reels_bufer_" + i + "_S0", "stop", [1]);
        madnes_anim_add("reels_bufer_" + i + "_S0", "blur", [0]);
        madnes_anim_add("reels_bufer_" + i + "_S1", "stop", [1]);
        madnes_anim_add("reels_bufer_" + i + "_S1", "blur", [0]);
        madnes_anim_add("reels_bufer_" + i + "_S2", "stop", [1]);
        madnes_anim_add("reels_bufer_" + i + "_S2", "blur", [0]);
        /*
        for(var anim in icons[picture_convert[server_config.logic.failResult[i][0]]])
        {
            madnes_anim_add("reels_bufer_" + i + "_S0", anim, icons[picture_convert[server_config.logic.failResult[i][0]]][anim]);
        }

        for(var anim in icons[picture_convert[server_config.logic.failResult[i][1]]])
        {
            madnes_anim_add("reels_bufer_" + i + "_S1", anim, icons[picture_convert[server_config.logic.failResult[i][1]]][anim]);
        }

        for(var anim in icons[picture_convert[server_config.logic.failResult[i][2]]])
        {
            madnes_anim_add("reels_bufer_" + i + "_S2", anim, icons[picture_convert[server_config.logic.failResult[i][2]]][anim]);
        }
        */
        madnes_anim_play("reels_bufer_" + i + "_S0", "stop");
        madnes_anim_play("reels_bufer_" + i + "_S1", "stop");
        madnes_anim_play("reels_bufer_" + i + "_S2", "stop");

        reels_pos[i] = 0;
    }
    /*
    for(var tmp0 in picture_convert)
    {
        madnes_add_sprite("reels_tmp_bufer_" + tmp0, picture_convert[tmp0], -9999, -9999);
    }
    */
    madnes_add_img("bckground2", "reels_cover", 0, 0);

    for(var i = 1; i <= 5; i++)
    {
        madnes_add_img("freespin_bg_"+(i-1), "freespin_Reels-" + i, -9999, 24);
    }

    for(var i = 1; i <= 3; i++)
    {
        for(var j = 1; j <= 5; j++)
        {
            var dira_pos = Math.floor( Math.random() * 3 % 3 + 1 );
            madnes_add_img("diry_"+(i-1)+"_"+(j-1)+"_dira", "dira" + dira_pos           , -9999, ico_he * ( i - 1 ) + 22);
            madnes_add_img("diry_"+(i-1)+"_"+(j-1)+"_ohen", "dira" + dira_pos + "_ohen" , -9999, ico_he * ( i - 1 ) + 22);

            madnes_add_group("diry_"+(i-1)+"_"+(j-1)+"_dust");
            madnes_set_pos("diry_"+(i-1)+"_"+(j-1)+"_dust", -9999, ico_he * ( i - 1 ) + 20 + 22 + 80);

            madnes_add_img("diry_"+(i-1)+"_"+(j-1)+"_dust_a", "dust"                      , 0, 0, 1, 0.5, 0.5);
            madnes_add_img("diry_"+(i-1)+"_"+(j-1)+"_dust_b", "dust"                      , 0, 0, 1, 0.5, 0.5);
            madnes_add_img("diry_"+(i-1)+"_"+(j-1)+"_dust_c", "dust"                      , 0, 0, 1, 0.5, 0.5);

            //madnes_set_blend_mode("diry_"+(i-1)+"_"+(j-1)+"_dust_a", PIXI.blendModes.ADD);
            //madnes_set_blend_mode("diry_"+(i-1)+"_"+(j-1)+"_dust_b", PIXI.blendModes.ADD);
            //madnes_set_blend_mode("diry_"+(i-1)+"_"+(j-1)+"_dust_c", PIXI.blendModes.ADD);


            madnes_set_angle("diry_"+(i-1)+"_"+(j-1)+"_dust_b", Math.random() * 90 + 90 * 1);
            madnes_set_angle("diry_"+(i-1)+"_"+(j-1)+"_dust_c", Math.random() * 90 + 90 * 2);

            madnes_add_to_group("diry_"+(i-1)+"_"+(j-1)+"_dust", "diry_"+(i-1)+"_"+(j-1)+"_dust_a");
            madnes_add_to_group("diry_"+(i-1)+"_"+(j-1)+"_dust", "diry_"+(i-1)+"_"+(j-1)+"_dust_b");
            madnes_add_to_group("diry_"+(i-1)+"_"+(j-1)+"_dust", "diry_"+(i-1)+"_"+(j-1)+"_dust_c");

        }
    }

    for(var i = 1; i <= 10; i++)
    {
        var lpos = i;
        if(lpos < 10)
        {
            lpos = "0" + lpos;
        }

        madnes_add_img("lines_"+i+"_line", "winline_" + lpos, -9999, -9999);
        madnes_add_img("lines_"+i+"_l", "winline_" + lpos + "_l", -9999, -9999);
        madnes_add_img("lines_"+i+"_r", "winline_" + lpos + "_r", -9999, -9999);
    }

    madnes_add_img("logo_reels", "logo_reels", wi / 2, -2, 1, 0.5, 0);

    madnes_add_img("table_free-spins", "table_free-spins", wi / 2, he, 1, 0.5, 1);

    madnes_add_bitmap_text("free1", "winfont", wi / 2 + 76, he , "0", 100);
    madnes_set_img_center("free1", 1, 1.52);
    madnes_add_bitmap_text("free2", "winfont", wi / 2 + 106, he , "0", 100);
    madnes_set_img_center("free2", 0, 1.52);

    freepanelpos = 200;
    madnes_set_pos_y("table_free-spins", he + freepanelpos);
    madnes_set_pos_y("free1", he + freepanelpos);
    madnes_set_pos_y("free2", he + freepanelpos);


    madnes_add_img("freespins_start", "freespins_start", -9999, -9999, 0, 0.5, 0.5);

    madnes_add_sprite("big-win_Start", "big-win_Start", -9999, 0)
    madnes_set_scale("big-win_Start", 2, 2);

    madnes_anim_add("big-win_Start", "boom_end", [8]);
    madnes_anim_add("big-win_Start", "boom", madnes_fill_range(0, 8));

    madnes_anim_add_oncomplete("big-win_Start", function () {
        madnes_anim_play("big-win_Start", "boom_end");
        wanted_boom_done();
    } );


    madnes_add_sprite("big_win_dynamite_shadow", "big_win_dynamite_shadow", -9999, -9999, 1, 0.5, 0.5);

    madnes_add_group("big_win_dynamite_group");
    madnes_add_sprite("big_win_dynamite", "big_win_dynamite", 0, 0, 1, 0.5, 0.5);
    madnes_add_to_group("big_win_dynamite_group", "big_win_dynamite");

    madnes_add_sprite("spark_sprite", "spark_sprite", 0, 0, 1, 0.5, 1.05);
    madnes_add_to_group("big_win_dynamite_group", "spark_sprite");

    madnes_anim_add("spark_sprite", "anim", madnes_fill_range(0, 7));

    madnes_set_pos("big_win_dynamite_group", -9999, -9999);
    madnes_set_angle("big_win_dynamite_group", 0);

    /*
    madnes_anim_loop("spark_sprite", "anim");

    madnes_set_angle("big_win_dynamite_shadow", 0);
    madnes_set_angle("big_win_dynamite_group", 0);
    madnes_rotate_to("big_win_dynamite_shadow", 45, 1, 950);
    madnes_rotate_to("big_win_dynamite_group", 45, 1, 950);

    madnes_set_pos("big_win_dynamite_shadow", wi / 2, he * 1.4);
    madnes_move_to("big_win_dynamite_shadow", wi * 0.5, he * 0.5, 950);

    madnes_set_pos("big_win_dynamite_group", wi / 2, he * 1.4);
    madnes_move_to("big_win_dynamite_group", wi * 0.5, he * 0.38, 650, function ()
        {
            madnes_move_to("big_win_dynamite_group", wi * 0.5, he * 0.5, 300);
        }
    );
    */


    madnes_add_img("big-win_Money", "big-win_Money", -9999, 0);

    for(var i = 0; i < 40; i++)
    {
        madnes_add_sprite("dollars_particle_" + i, "dollars_particle_" + Math.floor( ( Math.random() * 2 ) + 1), -9999, -9999, 1, 0.5, 0.5);
    }

    madnes_add_img("big-win_Paper", "big-win_Paper", -9999, 0);
    madnes_add_img("big-win_Text-1", "big-win_Text-1", -9999, 0);

    madnes_add_img("x2", "x2", -9999, 0);


    madnes_add_sprite("bonus_Intro", "bonus_Intro", -9999, 0);
    madnes_set_scale("bonus_Intro", 2, 2);

    madnes_anim_add("bonus_Intro", "begin", [0]);
    madnes_anim_add("bonus_Intro", "to_start", madnes_fill_range(0, 6));

    madnes_anim_add_oncomplete("bonus_Intro", function () {
        madnes_anim_play("bonus_Intro", "to_middle");
    });

    madnes_anim_add("bonus_Intro", "to_middle", [6]);
    madnes_anim_add_oncomplete("bonus_Intro", function () {
        wanted_saloon_to_middle();
    });

    madnes_anim_add("bonus_Intro", "to_end", madnes_fill_range(6, 14));
    madnes_anim_add_oncomplete("bonus_Intro", function () {
        madnes_anim_play("bonus_Intro", "to_done");
    });

    madnes_anim_add("bonus_Intro", "to_done", [14]);

    madnes_anim_add("bonus_Intro", "back_start", madnes_reverse(madnes_fill_range(6, 14)));
    madnes_anim_add_oncomplete("bonus_Intro", function () {
        madnes_anim_play("bonus_Intro", "back_middle");
    });

    madnes_anim_add("bonus_Intro", "back_middle", [6]);
    madnes_anim_add_oncomplete("bonus_Intro", function () {
        wanted_saloon_back_middle();
    });


    madnes_anim_add("bonus_Intro", "back_end", madnes_reverse(madnes_fill_range(0, 6)));
    madnes_anim_add_oncomplete("bonus_Intro", function () {
        madnes_anim_play("bonus_Intro", "back_done");
    });

    madnes_anim_add("bonus_Intro", "back_done", [0]);
    madnes_anim_add_oncomplete("bonus_Intro", function () {
        wanted_saloon_back_end();
    });

    // wanted_set_sounds();

    madnes_anim_play("bonus_Intro", "begin");

    madnes_audio_loop("BACKGROUND");

}


var settings_background_pos;
export function wanted_infomenu_init()
{
    settings_background_pos = 1;
    madnes_add_img("settings_background_1", "settings_background_1", -9999, -9999);
    madnes_add_img("settings_background_2", "settings_background_2", -9999, -9999);
    madnes_add_img("settings_background_3", "settings_background_3", -9999, -9999);
    madnes_add_img("settings_background_4", "settings_background_4", -9999, -9999);
    madnes_add_img("settings_background_5", "settings_background_5", -9999, -9999);

    madnes_add_group("settings_group_1");
    madnes_add_group("settings_group_2");
    madnes_add_group("settings_group_3");
    madnes_add_group("settings_group_4");
    madnes_add_group("settings_group_5");

    var left1 = 370;
    var left2 = 900;

    madnes_add_bitmap_text("ban_5", "winfont", left1, 72, "0", 100);
    madnes_add_bitmap_text("ban_4", "winfont", left1, 144, "0", 100);
    madnes_add_bitmap_text("ban_3", "winfont", left1, 216, "0", 100);
    madnes_set_img_center("ban_5", 1, 0);
    madnes_set_img_center("ban_4", 1, 0);
    madnes_set_img_center("ban_3", 1, 0);
    madnes_add_to_group("settings_group_1", "ban_5");
    madnes_add_to_group("settings_group_1", "ban_4");
    madnes_add_to_group("settings_group_1", "ban_3");


    madnes_add_bitmap_text("crd_5", "winfont", left2, 72, "0", 100);
    madnes_add_bitmap_text("crd_4", "winfont", left2, 144, "0", 100);
    madnes_add_bitmap_text("crd_3", "winfont", left2, 216, "0", 100);
    madnes_set_img_center("crd_5", 1, 0);
    madnes_set_img_center("crd_4", 1, 0);
    madnes_set_img_center("crd_3", 1, 0);
    madnes_add_to_group("settings_group_1", "crd_5");
    madnes_add_to_group("settings_group_1", "crd_4");
    madnes_add_to_group("settings_group_1", "crd_3");


    madnes_add_bitmap_text("whi_5", "winfont", left1, 322, "0", 100);
    madnes_add_bitmap_text("whi_4", "winfont", left1, 394, "0", 100);
    madnes_add_bitmap_text("whi_3", "winfont", left1, 466, "0", 100);
    madnes_add_bitmap_text("whi_2", "winfont", left1, 536, "0", 100);
    madnes_set_img_center("whi_5", 1, 0);
    madnes_set_img_center("whi_4", 1, 0);
    madnes_set_img_center("whi_3", 1, 0);
    madnes_set_img_center("whi_2", 1, 0);
    madnes_add_to_group("settings_group_1", "whi_5");
    madnes_add_to_group("settings_group_1", "whi_4");
    madnes_add_to_group("settings_group_1", "whi_3");
    madnes_add_to_group("settings_group_1", "whi_2");


    madnes_add_bitmap_text("clt_5", "winfont", left2, 322, "0", 100);
    madnes_add_bitmap_text("clt_4", "winfont", left2, 394, "0", 100);
    madnes_add_bitmap_text("clt_3", "winfont", left2, 466, "0", 100);
    madnes_add_bitmap_text("clt_2", "winfont", left2, 536, "0", 100);
    madnes_set_img_center("clt_5", 1, 0);
    madnes_set_img_center("clt_4", 1, 0);
    madnes_set_img_center("clt_3", 1, 0);
    madnes_set_img_center("clt_2", 1, 0);
    madnes_add_to_group("settings_group_1", "clt_5");
    madnes_add_to_group("settings_group_1", "clt_4");
    madnes_add_to_group("settings_group_1", "clt_3");
    madnes_add_to_group("settings_group_1", "clt_2");



    madnes_add_bitmap_text("bon_5", "winfont", 560, 76, "0", 100);
    madnes_add_bitmap_text("bon_4", "winfont", 560, 146, "0", 100);
    madnes_add_bitmap_text("bon_3", "winfont", 560, 216, "0", 100);
    madnes_set_img_center("bon_5", 1, 0);
    madnes_set_img_center("bon_4", 1, 0);
    madnes_set_img_center("bon_3", 1, 0);
    madnes_add_to_group("settings_group_2", "bon_5");
    madnes_add_to_group("settings_group_2", "bon_4");
    madnes_add_to_group("settings_group_2", "bon_3");

    madnes_add_bitmap_text("wld_5", "winfont", 530, 376, "0", 100);
    madnes_add_bitmap_text("wld_4", "winfont", 530, 446, "0", 100);
    madnes_add_bitmap_text("wld_3", "winfont", 530, 516, "0", 100);
    madnes_set_img_center("wld_5", 1, 0);
    madnes_set_img_center("wld_4", 1, 0);
    madnes_set_img_center("wld_3", 1, 0);
    madnes_add_to_group("settings_group_2", "wld_5");
    madnes_add_to_group("settings_group_2", "wld_4");
    madnes_add_to_group("settings_group_2", "wld_3");

    //madnes_add_img("wintable_text_bonus", "wintable_text_bonus", wi / 2 - 240, he / 2 - 10, 1, 0.5, 0.5);
    //madnes_add_to_group("settings_group_2", "wintable_text_bonus");

    var fsStyle1 = {
        "font": "25px gomarice_tanomuze_cowboy",
        "fill": "#000000",
        "fontWeight": "",
    };
    var fsStyle2 = {
        "font": "20px gomarice_tanomuze_cowboy",
        "fill": "#ffffff",
        "fontWeight": "",
        "strokeThickness": 2
    };
    let freespinsTxt, winTxt;
    if (systemConfig.get(CONFIG_PARAMS.LANGUAGE) === "es") {
        freespinsTxt = "GIROS GRATIS";
        winTxt = "GANA";
    } else {
        freespinsTxt = "FREESPINS";
        winTxt = "WIN";
        fsStyle2.font = "25px gomarice_tanomuze_cowboy";
    }
    madnes_add_text("30_freespins", 890,145, "30 " + freespinsTxt, fsStyle1);
    madnes_add_to_group("settings_group_2", "30_freespins");
    madnes_add_text("20_freespins", 890,218, "20 " + freespinsTxt, fsStyle1);
    madnes_add_to_group("settings_group_2", "20_freespins");
    madnes_add_text("10_freespins", 890,293, "10 " + freespinsTxt, fsStyle1);
    madnes_add_to_group("settings_group_2", "10_freespins");

    madnes_add_text("fseq", 950,80, freespinsTxt + " - " + winTxt + " x2", fsStyle2);
    madnes_set_angle("fseq", 21);
    madnes_add_to_group("settings_group_2", "fseq");


    madnes_set_pos("settings_group_1", -9999, -9999);
    madnes_set_pos("settings_group_2", -9999, -9999);
    madnes_set_pos("settings_group_3", -9999, -9999);
    madnes_set_pos("settings_group_4", -9999, -9999);
    madnes_set_pos("settings_group_5", -9999, -9999);

    var infotext = madnes_get_json("infotext");

    for(var i in infotext)
    {
        if(typeof infotext[i].page == "undefined")
        {
            continue;
        }
        var x = infotext[i].position[0];
        var y = infotext[i].position[1];
        var page = infotext[i].page;
        var lineHeight0 = infotext[i].lineHeight;
        var lineHeight1 = infotext[i].lineHeight;
        var x_add = 0;
        var center = 0;

        if(infotext[i].center && infotext[i].center == 1)
        {
            center = 1;
        }

        var style0 = {
            "font": "32px Arial",
            "fill": "#ffffff",
            "fontWeight": "",
        };
        var style1 = {
            "font": "32px Arial",
            "fill": "#ffffff",
            "fontWeight": "",
        };

        if(infotext[i].fontSize && infotext[i].font)
        {
            style0.font = infotext[i].fontSize + "px " + infotext[i].font;
            style1.font = infotext[i].fontSize + "px " + infotext[i].font;
        }
        if(infotext[i].color)
        {
            style0.fill = infotext[i].color;
            style1.fill = infotext[i].color;
        }
        if(infotext[i].bold)
        {
            if(infotext[i].bold == 1)
            {
                style0.fontWeight = "bold";
                style1.fontWeight = "bold";
            }
            else if(infotext[i].bold == 1)
            {
                style0.fontWeight = "";
                style1.fontWeight = "";
            }
        }

        if(infotext[i].title.fontSize && infotext[i].title.font)
        {
            style0.font = infotext[i].title.fontSize + "px " + infotext[i].title.font;
        }
        if(infotext[i].title.lineHeight)
        {
            lineHeight0 = infotext[i].title.lineHeight;
        }
        if(infotext[i].title.color)
        {
            style0.fill = infotext[i].title.color;
        }
        if(infotext[i].title.bold)
        {
            if(infotext[i].title.bold == 1)
            {
                style0.fontWeight = "bold";
            }
            else if(infotext[i].title.bold == 1)
            {
                style0.fontWeight = "";
            }
        }

        if(infotext[i].body.fontSize && infotext[i].body.font)
        {
            style1.font = infotext[i].body.fontSize + "px " + infotext[i].body.font;
        }
        if(infotext[i].body.color)
        {
            style1.fill = infotext[i].body.color;
        }
        if(infotext[i].body.lineHeight)
        {
            lineHeight1 = infotext[i].body.lineHeight;
        }
        if(infotext[i].body.bold)
        {
            if(infotext[i].body.bold == 1)
            {
                style1.fontWeight = "bold";
            }
            else if(infotext[i].body.bold == 1)
            {
                style1.fontWeight = "";
            }
        }
        if(infotext[i].body.x_add)
        {
            x_add = infotext[i].body.x_add;
        }

        var line0 = 0;
        var line1 = 0;

        for(var j in infotext[i].title.content)
        {
            var text = (infotext[i].title.content[j]).toUpperCase();
            madnes_add_text("info_header_" + i + "_"  + j + "_" + line0, x, y + line0 * lineHeight0, text, style0);
            if(center == 1)
            {
                madnes_set_img_center("info_header_" + i + "_"  + j + "_" + line0, 0.5, 0);
            }
            madnes_add_to_group("settings_group_" + ( page * 1 + 1 ), "info_header_" + i + "_"  + j + "_" + line0);
            line0++;
        }

        for(var j in infotext[i].body.content)
        {
            var text = infotext[i].body.content[j];
            madnes_add_text("info_body_" + i + "_"  + j + "_" + line1, x * 1 + x_add * 1, y + line0 * lineHeight0 + line1 * lineHeight1, text, style1);
            if(center == 1)
            {
                madnes_set_img_center("info_body_" + i + "_"  + j + "_" + line1, 0.5, 0);
            }
            madnes_add_to_group("settings_group_" + ( page * 1 + 1 ), "info_body_" + i + "_"  + j + "_" + line1);
            line1++;
        }

    }

    wanted_infomenu_update();
}

export let openinfo = false;

export function wanted_infomenu_open()
{
    settings_background_pos = 1;

    madnes_set_pos("settings_background_1", 0, 0);
    madnes_set_pos("settings_background_2", 2500, 0);
    madnes_set_pos("settings_background_3", 2500, 0);
    madnes_set_pos("settings_background_4", 2500, 0);
    madnes_set_pos("settings_background_5", 2500, 0);

    madnes_set_pos("settings_group_1", 0, 0);
    madnes_set_pos("settings_group_2", 2500, 0);
    madnes_set_pos("settings_group_3", 2500, 0);
    madnes_set_pos("settings_group_4", 2500, 0);
    madnes_set_pos("settings_group_5", 2500, 0);

    openinfo = true;
}

export function wanted_infomenu_close()
{
    madnes_set_pos("settings_background_1", -9999, -9999);
    madnes_set_pos("settings_background_2", -9999, -9999);
    madnes_set_pos("settings_background_3", -9999, -9999);
    madnes_set_pos("settings_background_4", -9999, -9999);
    madnes_set_pos("settings_background_5", -9999, -9999);

    madnes_set_pos("settings_group_1", -9999, -9999);
    madnes_set_pos("settings_group_2", -9999, -9999);
    madnes_set_pos("settings_group_3", -9999, -9999);
    madnes_set_pos("settings_group_4", -9999, -9999);
    madnes_set_pos("settings_group_5", -9999, -9999);

    openinfo = false;
}

export function wanted_infomenu_update()
{
    var max_wi = 166;

    madnes_set_bitmap_float("whi_2", server_config.logic.symbols[0].factors[1] * bet, max_wi);
    madnes_set_bitmap_float("whi_3", server_config.logic.symbols[0].factors[2] * bet, max_wi);
    madnes_set_bitmap_float("whi_4", server_config.logic.symbols[0].factors[3] * bet, max_wi);
    madnes_set_bitmap_float("whi_5", server_config.logic.symbols[0].factors[4] * bet, max_wi);

    madnes_set_bitmap_float("clt_2", server_config.logic.symbols[1].factors[1] * bet, max_wi);
    madnes_set_bitmap_float("clt_3", server_config.logic.symbols[1].factors[2] * bet, max_wi);
    madnes_set_bitmap_float("clt_4", server_config.logic.symbols[1].factors[3] * bet, max_wi);
    madnes_set_bitmap_float("clt_5", server_config.logic.symbols[1].factors[4] * bet, max_wi);

    madnes_set_bitmap_float("crd_3", server_config.logic.symbols[3].factors[2] * bet, max_wi);
    madnes_set_bitmap_float("crd_4", server_config.logic.symbols[3].factors[3] * bet, max_wi);
    madnes_set_bitmap_float("crd_5", server_config.logic.symbols[3].factors[4] * bet, max_wi);

    madnes_set_bitmap_float("ban_3", server_config.logic.symbols[4].factors[2] * bet, max_wi);
    madnes_set_bitmap_float("ban_4", server_config.logic.symbols[4].factors[3] * bet, max_wi);
    madnes_set_bitmap_float("ban_5", server_config.logic.symbols[4].factors[4] * bet, max_wi);

    madnes_set_bitmap_float("bon_3", server_config.logic.symbols[8].factors[2] * bet, 146);
    madnes_set_bitmap_float("bon_4", server_config.logic.symbols[8].factors[3] * bet, 146);
    madnes_set_bitmap_float("bon_5", server_config.logic.symbols[8].factors[4] * bet, 146);

    madnes_set_bitmap_float("wld_3", server_config.logic.symbols[10].factors[2] * bet, 170);
    madnes_set_bitmap_float("wld_4", server_config.logic.symbols[10].factors[3] * bet, 170);
    madnes_set_bitmap_float("wld_5", server_config.logic.symbols[10].factors[4] * bet, 170);
}

var move_start = 0;
var move_total = 250;
export function wanted_infomenu_left()
{
    if(!openinfo) return;
    if(wanted_infomenu_move_in == 0)
    {
        move_start = madnes_get_currtime();
        wanted_infomenu_move_in = 1;
        wanted_infomenu_move_dir = 1;
        madnes_add_to_render(wanted_infomenu_move);
    }
}

export function wanted_infomenu_right()
{
    if(!openinfo) return;
    if(wanted_infomenu_move_in == 0)
    {
        move_start = madnes_get_currtime();
        wanted_infomenu_move_in = 1;
        wanted_infomenu_move_dir = -1;
        madnes_add_to_render(wanted_infomenu_move);
    }
}

var wanted_infomenu_move_in = 0;
var wanted_infomenu_move_dir = 0;
var settings_background_pos2;

function wanted_infomenu_move()
{
    var difftime = madnes_get_currtime() - move_start;
    var end = 0;
    if(difftime > move_total)
    {
        difftime = move_total;
        end = 1;
    }

    settings_background_pos2 = settings_background_pos * 1 + ( wanted_infomenu_move_dir * -1 );
    if(settings_background_pos2 > 5)
    {
        settings_background_pos2 = 1;
    }
    if(settings_background_pos2 < 1)
    {
        settings_background_pos2 = 5;
    }

    var pos1 = wi * ( ( ( 100 / move_total ) * difftime ) / 100 ) * wanted_infomenu_move_dir;
    if(wanted_infomenu_move_dir < 0)
    {
        var pos2 = pos1 + wi;
    }
    else
    {
        var pos2 = wi * -1 + pos1;
    }

    madnes_set_pos_x("settings_background_" + settings_background_pos, pos1, 0);
    madnes_set_pos_x("settings_background_" + settings_background_pos2, pos2, 0);

    madnes_set_pos_x("settings_group_" + settings_background_pos, pos1, 0);
    madnes_set_pos_x("settings_group_" + settings_background_pos2, pos2, 0);

    if(end == 1)
    {
        madnes_rem_from_render(wanted_infomenu_move);

        madnes_set_pos_x("settings_background_" + settings_background_pos2, 0, 0);
        madnes_set_pos_x("settings_background_" + settings_background_pos, 2500, 0);

        madnes_set_pos_x("settings_group_" + settings_background_pos2, 0, 0);
        madnes_set_pos_x("settings_group_" + settings_background_pos, 2500, 0);

        settings_background_pos = settings_background_pos2;
        wanted_infomenu_move_in = 0;
        wanted_infomenu_move_dir = 0;
    }
}

let in_smoke_pos = 0;

// Render pro kourovy efekt
function wanted_render_phaser()
{
    if(in_smoke_pos++%3==0 && smoke_emitter != null)
    {
        for(var i = 0; i < 5; i++)
        {
            if(freespin_state != null && freespin_state[i] != null && freespin_state[i] == 1)
            {
                if(madnes_check_focus())
                {
                    var xpos = null;
                    switch(i){
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4: xpos = [(cylinder_pos[i]+25)*wi_scale,(cylinder_pos[i]-25+ico_wi)*wi_scale]; break;
                        default: xpos = [-9999, -9999];
                            break;
                    }
                    var rep = 5;
                    var freq = 30;
                    smoke_emitter[i].emit('smoke', xpos, he*he_scale*0.85, { repeat: rep, frequency: freq });
                }
            }
        }
    }
}
